import { alpha, Box, Stack, SvgIcon, Typography } from '@mui/material';
import { ReactComponent as DescriptionIcon } from 'src/assets/description-icon.svg';

export const VideoInterviewInstructions = ({ isTech }: { isTech: boolean }) => {
  return (
    <Box
      sx={(theme) => ({
        gap: 2,
        mb: 3,
        mt: 1,
        padding: '1.5rem 1.5rem 1.25rem',
        bgcolor: alpha(theme.palette.background.brandSecondary, 0.05),
        borderRadius: '1rem',

        [theme.breakpoints.down('md')]: {
          flexDirection: 'column',
          alignItems: 'flex-start',
          textAlign: 'left',
        },
        [theme.breakpoints.down('sm')]: {
          borderRadius: '0',
          mx: '-1.5rem',
          padding: '1rem 1.5rem 1.25rem ',
        },
      })}
    >
      <Typography
        sx={(theme) => ({
          fontFamily: 'Montserrat',
          fontWeight: 500,
          fontSize: '16px',
          lineHeight: '150%',
          letterSpacing: '-0.02em',
          color: '#000000',
          marginBottom: '16px',
          width: '100%',
          textAlign: 'left',

          [theme.breakpoints.down('sm')]: {
            fontSize: '12px',
          },
        })}
      >
        {isTech ? (
          <>
            This quick video allows us to check your English and lets you <br />
            move forward now, avoiding the hassle of scheduling and <br /> the
            pressure of an on-the-spot interview.
          </>
        ) : (
          <>
            This short video is our chance to learn a bit about your <br />
            experience and see your communication skills in action. <br />
            It also lets you move forward now, avoiding the hassle <br /> of
            scheduling and the pressure of a live call.
          </>
        )}
      </Typography>

      <Stack spacing={0.5}>
        <Box display="flex" alignItems="flex-start" gap={1}>
          <Typography
            component="span"
            sx={{
              color: '#BB28BE',
              fontSize: '20px',
              lineHeight: '24px',
              flexShrink: 0,
            }}
          >
            <Box
              sx={{
                borderRadius: '0.5rem',
                backgroundColor: 'rgba(187, 40, 190, 0.06)',
                padding: '4px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'start',
                flexShrink: 0,
              }}
            >
              <SvgIcon
                inheritViewBox
                component={DescriptionIcon}
                sx={() => ({
                  width: '16px',
                  height: '16px',
                })}
              />
            </Box>
          </Typography>
          <Typography
            sx={(theme) => ({
              fontFamily: 'Montserrat',
              fontWeight: 500,
              fontSize: '16px',
              lineHeight: '150%',
              letterSpacing: '-0.02em',
              color: '#BB28BE',
              textAlign: 'left',

              [theme.breakpoints.down('sm')]: {
                fontSize: '12px',
              },
            })}
          >
            {isTech
              ? 'Focus on communication, not technical accuracy.'
              : 'Be prepared to tell us briefly about your experience.'}
          </Typography>
        </Box>

        <Box display="flex" alignItems="flex-start" gap={1}>
          <Typography
            component="span"
            sx={{
              color: '#BB28BE',
              fontSize: '20px',
              lineHeight: '24px',
              flexShrink: 0,
            }}
          >
            <Box
              sx={{
                borderRadius: '0.5rem',
                backgroundColor: 'rgba(187, 40, 190, 0.06)',
                padding: '4px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'start',
                flexShrink: 0,
              }}
            >
              <SvgIcon
                inheritViewBox
                component={DescriptionIcon}
                sx={() => ({
                  width: '16px',
                  height: '16px',
                })}
              />
            </Box>
          </Typography>
          <Typography
            sx={(theme) => ({
              fontFamily: 'Montserrat',
              fontWeight: 500,
              fontSize: '16px',
              lineHeight: '150%',
              letterSpacing: '-0.02em',
              color: '#BB28BE',
              textAlign: 'left',

              [theme.breakpoints.down('sm')]: {
                fontSize: '12px',
              },
            })}
          >
            Speak naturally and avoid reading from notes.
          </Typography>
        </Box>
      </Stack>
    </Box>
  );
};
